<script setup lang="ts">
import { useBriefings } from '~/composables/useBriefings'
import { useAuthStore } from '~/stores/auth'
import { ResponseStatus } from '~/types/app.type'

useHead({ title: 'Briefings | Benchmark Source' })

const { getBriefings } = useBriefings()
const authStore = useAuthStore()
const isAuthenticated = computed(() => authStore.isAuthenticated)

const { data, status } = useAsyncData(
  async () => {
    return getBriefings([
      'critical-minerals',
      'batteries',
      'geopolitics',
      'sustainability',
      'new-energy',
    ])
  },
  {
    watch: [isAuthenticated],
    server: false,
    default: () => [],
  },
)

const briefings = computed(() => data.value)
const loading = computed(() => status.value !== ResponseStatus.SUCCESS)
</script>

<template>
  <div class="min-h-[600px]">
    <LoadingSpinner v-if="loading" wrap-screen-with-submenu />
    <section v-else class="mx-auto max-w-content-container px-5 py-3 md:py-12">
      <h1
        v-if="briefings?.length === 0"
        class="text-center font-semibold text-lg md:text-xl mb-6"
      >
        No briefings available at the moment.
      </h1>
      <div
        v-else
        class="grid grid-cols-1 sm:grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4 w-full"
      >
        <BriefingCard
          v-for="briefing in briefings"
          :key="briefing.slug"
          :title="briefing.archiveTitle"
          :publication-frequency="briefing.publicationFrequency"
          :date="briefing.date"
          :slug="briefing.slug"
          :image="briefing.image"
          :viewer-can-read="briefing.viewerCanRead"
          :excerpt="briefing.excerpt"
          :time-to-read="briefing.timeToRead"
          :link="briefing.link"
        />
      </div>
    </section>
  </div>
</template>
